import { HttpStatusCode } from '@thesavingsgroup/enums/HttpStatusCode';
import find from 'lodash/find';
import get from 'lodash/get';
import head from 'lodash/head';

import { PinDeliverEmbeddedError } from '../types/PinDeliverEmbeddedError';

/**
 * Extracts a HTTP status code from a pin delivery error response.
 *
 * This helper is used to determine the most appropriate status code to drive
 * localized error messaging, since the backend may return multiple embedded errors.
 *
 * @param error - The error object returned from a failed API request.
 * @returns A status code representing the error, or undefined if none found.
 */
export const extractPinDeliverErrorStatus = (
  error: unknown,
): number | undefined => {
  const errors: PinDeliverEmbeddedError[] = get(
    error,
    'response.data._embedded.errors',
    [],
  );

  const fallbackStatus: number | undefined = get(
    error as any,
    'response.status',
  );

  const conflictError = find(errors, { statusCode: HttpStatusCode.CONFLICT });
  const firstError = head(errors);

  if (conflictError) {
    return conflictError.statusCode;
  }

  if (firstError) {
    return firstError.statusCode;
  }

  return fallbackStatus;
};
